import { Buffer } from 'buffer'
globalThis.Buffer = Buffer

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { inject } from '@vercel/analytics'
import './index.css'
import App from './App'

// Sentry — error tracking (só em produção)
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_VERCEL_ENV || 'production',
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: 0.2,
    replaysOnErrorSampleRate: 0,
  })
}

// Suprimir PWA install prompt em rotas públicas (/p/, /cliente/atualizar, /cliente/bem-vindo)
window.addEventListener('beforeinstallprompt', (e) => {
  const path = window.location.pathname
  if (path.startsWith('/p/') || path.startsWith('/cliente/atualizar') || path.startsWith('/cliente/bem-vindo')) {
    e.preventDefault()
  }
})

inject()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
